/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { Input, Select } from '@ui/components';
import FormGroup, {
    FormGroupHint,
    FormGroupLabel,
} from '@ui/components/FormGroup';

const metricOptions = [
    { label: 'Impressions', value: 'impressions' },
    { label: 'Media value', value: 'media-value' },
    { label: 'Engagements', value: 'engagements' },
];

export const LabelOnlyFormGroupExample = () => (
    <FormGroup data-test="metric-field">
        <FormGroupLabel text="Social metric" />
        <Select options={metricOptions} placeholder="Select a metric" />
    </FormGroup>
);

export const LabelAndHintFormGroupExample = () => (
    <FormGroup>
        <FormGroupLabel text="Campaign name" />
        <Input placeholder="Spring sponsorship" />
        <FormGroupHint>Shown on exported reports and dashboards.</FormGroupHint>
    </FormGroup>
);

export const RequiredFormGroupExample = () => (
    <FormGroup>
        <FormGroupLabel required text="Rightsholder" />
        <Select options={metricOptions} placeholder="Select a rightsholder" />
    </FormGroup>
);

export const ErrorFormGroupExample = () => (
    <FormGroup context="danger">
        <FormGroupLabel required text="Sponsor" />
        <Select options={metricOptions} placeholder="Select a sponsor" />
        <FormGroupHint>A sponsor is required to continue.</FormGroupHint>
    </FormGroup>
);

export const ComposedFieldFormGroupExample = () => (
    <FormGroup>
        <FormGroupLabel text="Goal target" />
        <Input placeholder="0" />
        <FormGroupHint>
            Enter the target value the pacing goal should reach.
        </FormGroupHint>
    </FormGroup>
);
